import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import Button from "@mui/material/Button";
import * as React from "react";
import i18nStore from "../../../i18n/store";


export interface DeleteUnattachedRowsButtonProps {
    onClick: () => void;
    disabled?: boolean;
}


const DeleteUnattachedRowsButton = (props: DeleteUnattachedRowsButtonProps) => {
    const translations = i18nStore.getTranslations;

    return (
        <Button
            color="warning"
            variant="contained"
            startIcon={<AutoFixHighIcon/>}
            onClick={() => {
                props.onClick();
            }}
            disabled={props.disabled}
        >
            {translations.dropUnattachedRows}
        </Button>
    );
}

export default DeleteUnattachedRowsButton;
